//* Style
import FilterPostsStyle from './style';

//* Components
import Button from '@/components/Button';

const FilterPosts = ({ onFilterChange, categoryData, className, filterKey, searchParams }) => {
	return (
		<FilterPostsStyle className={className || ''}>
			{/* <Button
				text={'all'}
				className={`category tag ${searchParams.get(filterKey) == null ? 'active' : ''}`}
				onClick={() => {
					onFilterChange(filterKey, null);
				}}
			/>
			{categoryData.data.map((item) => {
				return (
					<Button
						key={item.id}
						className={`category tag ${searchParams.get(filterKey) == item.id ? 'active' : ''}`}
						onClick={() => {
							onFilterChange(filterKey, item.id);
						}}>
						{item.name}
					</Button>
				);
			})} */}
		</FilterPostsStyle>
	);
};

export default FilterPosts;
